import { lazy } from 'react';

const Mock = lazy(() => import('./mock'));
const Home = lazy(() => import('./home'));
const Profile = lazy(() => import('./profile'));

export { Mock, Home, Profile };
